export enum ISex {
  Male = "male",
  Female = "female",
  Other = "other",
}
